var exports = {
  "k": "x2b2fbebb--d1f784--container",
};

module.exports = exports;
